import _objectSpread from '@babel/runtime-corejs3/helpers/esm/objectSpread2';
import _defineProperty from '@babel/runtime-corejs3/helpers/esm/defineProperty';
import _objectWithoutProperties from '@babel/runtime-corejs3/helpers/esm/objectWithoutProperties';
import { createElement } from 'react';
import { c as classNames } from '../../shared/bind-d9144132.js';
import { interpolateWithHtml } from '../../utils/interpolateWithHtml.js';

var styles = {
  "unit-base": "4",
  "text": "web_ui__Text__text",
  "html-content": "web_ui__Text__html-content",
  "inverse": "web_ui__Text__inverse",
  "heading-xxl": "web_ui__Text__heading-xxl",
  "heading-xl": "web_ui__Text__heading-xl",
  "heading": "web_ui__Text__heading",
  "section-heading": "web_ui__Text__section-heading",
  "title": "web_ui__Text__title",
  "body": "web_ui__Text__body",
  "user-input": "web_ui__Text__user-input",
  "subtitle": "web_ui__Text__subtitle",
  "caption": "web_ui__Text__caption",
  "primary": "web_ui__Text__primary",
  "amplified": "web_ui__Text__amplified",
  "muted": "web_ui__Text__muted",
  "success": "web_ui__Text__success",
  "warning": "web_ui__Text__warning",
  "expose": "web_ui__Text__expose",
  "left": "web_ui__Text__left",
  "left@phones": "web_ui__Text__left--phones",
  "right": "web_ui__Text__right",
  "right@phones": "web_ui__Text__right--phones",
  "center": "web_ui__Text__center",
  "center@phones": "web_ui__Text__center--phones",
  "parent": "web_ui__Text__parent",
  "highlight": "web_ui__Text__highlight",
  "highlight-primary": "web_ui__Text__highlight-primary",
  "highlight-amplified": "web_ui__Text__highlight-amplified",
  "highlight-muted": "web_ui__Text__highlight-muted",
  "highlight-success": "web_ui__Text__highlight-success",
  "highlight-warning": "web_ui__Text__highlight-warning",
  "highlight-expose": "web_ui__Text__highlight-expose",
  "highlight-inverse": "web_ui__Text__highlight-inverse",
  "bold": "web_ui__Text__bold",
  "truncated": "web_ui__Text__truncated",
  "max-lines": "web_ui__Text__max-lines",
  "clickable": "web_ui__Text__clickable",
  "underline": "web_ui__Text__underline",
  "underline-none": "web_ui__Text__underline-none",
  "strikethrough": "web_ui__Text__strikethrough",
  "inherit": "web_ui__Text__inherit",
  "format": "web_ui__Text__format",
  "inline": "web_ui__Text__inline"
};

var _excluded = ["type", "id", "as", "highlightTheme", "alignment", "text", "highlight", "html", "theme", "width", "children", "truncate", "clickable", "aria", "title", "testId", "underline", "role", "tabIndex", "maxLines"];
var Type = /*#__PURE__*/function (Type) {
  Type["HeadingXXL"] = "heading-xxl";
  Type["HeadingXL"] = "heading-xl";
  Type["Heading"] = "heading";
  Type["SectionHeading"] = "section-heading";
  Type["Title"] = "title";
  Type["Body"] = "body";
  Type["UserInput"] = "user-input";
  Type["Subtitle"] = "subtitle";
  Type["Caption"] = "caption";
  return Type;
}({});
var Alignment = /*#__PURE__*/function (Alignment) {
  Alignment["Left"] = "left";
  Alignment["Center"] = "center";
  Alignment["Right"] = "right";
  return Alignment;
}(Alignment || {});
var Width = /*#__PURE__*/function (Width) {
  Width["Parent"] = "parent";
  return Width;
}(Width || {});
var cssClasses = classNames.bind(styles);
var Text = function Text(_ref) {
  var _ref$type = _ref.type,
    type = _ref$type === void 0 ? Type.Body : _ref$type,
    id = _ref.id,
    as = _ref.as,
    _ref$highlightTheme = _ref.highlightTheme,
    highlightTheme = _ref$highlightTheme === void 0 ? 'amplified' : _ref$highlightTheme,
    _ref$alignment = _ref.alignment,
    alignment = _ref$alignment === void 0 ? Alignment.Left : _ref$alignment,
    _ref$text = _ref.text,
    text = _ref$text === void 0 ? '' : _ref$text,
    highlight = _ref.highlight,
    html = _ref.html,
    theme = _ref.theme,
    width = _ref.width,
    children = _ref.children,
    truncate = _ref.truncate,
    clickable = _ref.clickable,
    aria = _ref.aria,
    title = _ref.title,
    testId = _ref.testId,
    underline = _ref.underline,
    role = _ref.role,
    tabIndex = _ref.tabIndex,
    maxLines = _ref.maxLines,
    booleanClasses = _objectWithoutProperties(_ref, _excluded);
  var textProp = typeof text === 'number' ? text.toString() : text;
  var content = textProp || children;
  var textClass = cssClasses(styles.text, type, alignment, theme, width, booleanClasses, _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({
    clickable: clickable,
    truncated: truncate
  }, "highlight-".concat(highlightTheme), highlight), "highlight", highlight), "underline", underline), 'underline-none', underline === false), 'max-lines', typeof maxLines === 'number'), 'html-content', html));
  var elementAttributes = _objectSpread(_objectSpread({}, aria), {}, {
    title: title,
    id: id,
    className: textClass,
    role: role,
    tabIndex: tabIndex,
    'data-testid': testId
  }, typeof maxLines === 'number' && {
    style: {
      '--max-lines': maxLines
    }
  });
  var element = /*#__PURE__*/createElement(as, elementAttributes, content);
  if (html) return interpolateWithHtml(element);
  return element;
};
Text.Type = Type;
Text.Alignment = Alignment;
Text.Width = Width;

export { Type, Text as default };
//# sourceMappingURL=Text.js.map
